export const theme = {
  colors: {
    bg: '#0b1117',
    bgSecondary: '#111922',
    bgCard: '#151f2b',
    primary: '#c88b3a',
    primaryLight: '#e6b866',
    secondary: '#8da0b3',
    secondaryLight: '#c7d3df',
    text: '#f3f6f9',
    textMuted: '#90a0b0',
    textSecondary: '#cad4dd',
    border: '#263241',
    primaryRgb: '200, 139, 58',
    secondaryRgb: '141, 160, 179',
    gradient: 'linear-gradient(135deg, #b87830 0%, #e6b866 100%)',
    gradientHover: 'linear-gradient(135deg, #a26728 0%, #d8a650 100%)',
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  shadows: {
    card: '0 18px 36px rgba(5, 10, 16, 0.28)',
    glow: '0 16px 36px rgba(200, 139, 58, 0.24)',
    glowCyan: '0 16px 34px rgba(141, 160, 179, 0.16)',
  },
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.15s ease',
  },
} as const;

export type Theme = typeof theme;
